import React from 'react';
import {Image, UnstyledButton} from "@mantine/core";
import cx from "clsx";
import {ReadMoreNoLink} from "@/app/(index)/read-more";
import {Poppins} from 'next/font/google';
import {useMediaQuery} from "@mantine/hooks";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";

const poppins = Poppins({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

interface IProps {
    name: string;
    url: string;
    image: string;
    border?: boolean;
    handleEnLinkInfo: (tag: string) => void;
    tag?: string;
}

const CoreResource: React.FC<IProps> = ( { name, url, image, border = true } ) => {
    return (
        <UnstyledButton component="a" target="_blank" href={ `https://${url}` }>
            <div
                className={cx("w-[337px] h-[300px] flex flex-col p-[22px] group", border && "border-r border-dotted border-[#cccccc]")}>
                <div className="mb-[35px] opacity-80 group-hover:opacity-100">
                    <Image src={`/images/${image}.png`} h={114} w={241}/>
                </div>
                <div>
                    <div className="text-[20px] font-bold text-black">{name}</div>
                    <div
                        className={cx("text-[12px] text-[#b6b6b6] font-normal", poppins.className)}>
                        {url}
                    </div>
                    <div className="mt-[25px]">
                        <ReadMoreNoLink/>
                    </div>
                </div>
            </div>
        </UnstyledButton>
    );
}


export const CoreResource2: React.FC<IProps> = ( { name, url, image, handleEnLinkInfo, tag } ) => {
    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    const { lang } = useGlobalStateStore();

    const enLinkInfo = () => {
        handleEnLinkInfo(tag!!);
    }

    return (
        lang == "tw" ? (
            <UnstyledButton component="a" target="_blank" href={ `https://${url}` }>
                <div className={"flex flex-col group items-center"}>
                    <div className="mb-[10px] opacity-80 group-hover:opacity-100">
                        <Image src={`/images/${image}.png`} h={mediaQueryLessSM ? 114 : 55} w={mediaQueryLessSM ? 241 : 120}/>
                    </div>
                    <div className={cx("font-bold text-black text-center", mediaQueryLessSM ? "text-[22px]" : "text-[14px]")}>{name}</div>
                    {
                        mediaQueryLessSM && (
                            <div
                                className={cx("text-[17px] text-[#b6b6b6] font-bold", poppins.className)}>
                                {url}
                            </div>
                        )
                    }
                </div>
            </UnstyledButton>
        ) : (
            <UnstyledButton onClick={enLinkInfo}>
                <div className={"flex flex-col group items-center"}>
                    <div className="mb-[10px] opacity-80 group-hover:opacity-100">
                        <Image src={`/images/${image}.png`} h={mediaQueryLessSM ? 114 : 55} w={mediaQueryLessSM ? 241 : 120}/>
                    </div>
                    <div className={cx("font-bold text-black text-center", mediaQueryLessSM ? lang == "tw" ? "text-[22px]" : "text-[18px]" : lang == "tw" ? "text-[14px]" : "text-[12px]")}>
                        {name}
                    </div>
                    {
                        mediaQueryLessSM && (
                            <div
                                className={cx("text-[17px] text-[#b6b6b6] font-bold", poppins.className)}>
                                {url}
                            </div>
                        )
                    }
                </div>
            </UnstyledButton>
        )
    );
}

export default CoreResource;
